import { render } from "./modConfigUser.vue?vue&type=template&id=30090a36&scoped=true"
import script from "./modConfigUser.vue?vue&type=script&lang=js"
export * from "./modConfigUser.vue?vue&type=script&lang=js"

import "./modConfigUser.vue?vue&type=style&index=0&id=30090a36&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30090a36"]])

export default __exports__